/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 01 2024
 **/

import { useEffect, useState } from "react";
import { timer } from "rxjs";

import { _T } from "@rfice/language";

import { useTusUploadTargetRenderer, useUploadTus } from "@/frameworks/core/hooks";
import { Column, Typography } from "@/frameworks/designStuff/components";
import { ZIndex } from "@/frameworks/core/commons";
import { FileUploadList, S, UploadingStatus } from "./private";

export default function FileUploadStatePopup() {
	const tusUploadState = useTusUploadTargetRenderer("FILEBOX");
	const [isOpen, setIsOpen] = useState(false);
	const { clearUploadedState } = useUploadTus();

	const uploadingFileCount = Object.keys(tusUploadState).length;
	const isUploadFinished = Object.values(tusUploadState).every((state) => state.status !== "pending");

	useEffect(() => {
		if (uploadingFileCount === 0) {
			timer(2000).subscribe(() => {
				setIsOpen(false);
				clearUploadedState();
			});
			return;
		}

		if (isUploadFinished) {
			timer(2000).subscribe(() => {
				setIsOpen(false);
				clearUploadedState();
			});
		} else {
			setIsOpen(true);
		}
	}, [isUploadFinished, uploadingFileCount]);

	if (!isOpen) return;
	return (
		<S.StateUploadPopupContainer zIndex={ZIndex.POPUP}>
			<S.StyledFileStateUploadPopup gap={24}>
				<Typography typoSize="Head6">{_T("파일 추가")}</Typography>
				<Column gap={12} css={{ width: "100%" }}>
					<UploadingStatus />
					<FileUploadList />
				</Column>
			</S.StyledFileStateUploadPopup>
		</S.StateUploadPopupContainer>
	);
}
